var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 16,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal_1_1",
    "data-name": "medal (1) 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M8.19,12.706A6.353,6.353,0,1,0,1.837,6.353,6.353,6.353,0,0,0,8.19,12.706Z",
    transform: "translate(-0.204)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M2.921,11.328.735,15.117l2.551-.135,1.159,2.277,2.022-3.506A6.347,6.347,0,0,1,2.921,11.328Z",
    transform: "translate(-0.082 -1.259)",
    fill: "#6a36f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M14.346,11.307a6.348,6.348,0,0,1-3.537,2.438l2.028,3.512L14,14.979l2.551.135Z",
    transform: "translate(-1.201 -1.256)",
    fill: "#6a36f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M8.408,11.176a4.6,4.6,0,1,0-4.6-4.6A4.6,4.6,0,0,0,8.408,11.176Z",
    transform: "translate(-0.423 -0.219)",
    fill: "#f8b64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M11.737,6.264a.241.241,0,0,0-.132-.409L9.787,5.59a.237.237,0,0,1-.18-.132L8.795,3.81a.24.24,0,0,0-.431,0L7.554,5.458a.25.25,0,0,1-.18.132l-1.817.265a.241.241,0,0,0-.132.409L6.738,7.546a.243.243,0,0,1,.069.211L6.5,9.565a.24.24,0,0,0,.35.252l1.625-.854a.235.235,0,0,1,.224,0l1.625.854a.241.241,0,0,0,.35-.252L10.36,7.757a.237.237,0,0,1,.069-.211Z",
    transform: "translate(-0.595 -0.408)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.07b1bed3cdfe9a9ddfbcfee373008ca0.svg";
export { ForwardRef as ReactComponent };